import { render, staticRenderFns } from "./project-statement.vue?vue&type=template&id=3143ab50&scoped=true"
import script from "./project-statement.vue?vue&type=script&lang=js"
export * from "./project-statement.vue?vue&type=script&lang=js"
import style0 from "./project-statement.vue?vue&type=style&index=0&id=3143ab50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3143ab50",
  null
  
)

export default component.exports